import { Mapper } from "../../../../base/utils/mapper";

import { TeleconsultaModel }
from "../../../../domain/models/consult/teleconsulta.model";

import { TeleconsultaEntity }
from "../entities/teleconsulta.entity";

export class TeleconsultaImplementationRepositoryMapper
extends Mapper<
TeleconsultaEntity,
TeleconsultaModel
> {

    mapFrom(param:
    TeleconsultaEntity):
    TeleconsultaModel {

        return {
            ...param
        };
    }

    mapTo(param:
    TeleconsultaModel):
    TeleconsultaEntity {

        return {
            ...param
        };
    }
}